import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-map-content-selector',
  templateUrl: './map-content-selector.component.html',
  styleUrls: ['./map-content-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapContentSelectorComponent {
  @Input() text: string;
  @Input() showIcon: boolean;
}
